import { z } from 'zod';

export const createBookingSearchSchema = z.object({
  travelId: z.string().uuid(),
});
